import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailRequestItComponent from './loansDetailRequestIt.component';

let loansDetailRequestItModule = angular.module('loansDetailRequestIt', [
  uiRouter
])

.component('loansDetailRequestIt', loansDetailRequestItComponent)

.name;

export default loansDetailRequestItModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailRequestIt/loansDetailRequestIt.js